import UrlHelper from "./UrlHelper";

export const LINK_HOME = "/home"
export const LINK_HOME_MAIN = "/"
export const LINK_CONTACT_RELATIVE = "/contact"
export const LINK_WERKVERZEICHNIS_RELATIVE = "/catalogueOfWorks"
export const LINK_WERKVERZEICHNIS_ABSOLUTE = UrlHelper.join(LINK_HOME, LINK_WERKVERZEICHNIS_RELATIVE)
export const LINK_CONTACT_ABSOLUTE = UrlHelper.join(LINK_HOME, LINK_CONTACT_RELATIVE)
export const LINK_ALL_CATEGORIES_RELATIVE = "/categories"
export const LINK_ALL_CATEGORIES_ABSOLUTE = UrlHelper.join(LINK_HOME, LINK_ALL_CATEGORIES_RELATIVE)
export const LINK_CATEGORY_OVERVIEW = "/categories/:category"
export const LINK_SINGLE_PROJECT_VIEW = "/categories/:category/:project_url_id"
export const LINK_SINGLE_PROJECT_VIEW_FROM_WERKVERZEICHNIS = "/project/:project_url_id"
export const LINK_ADMIN = "/admin"
export const LINK_SET_PASSWORD = UrlHelper.join(LINK_ADMIN,"#/SetPassword");
export const LINK_INVITE_ACCEPTED = "/InviteAccepted"
